import React from 'react';
import { FormControl as ChakraFormControl, FormControlProps as ChakraFormControlProps } from '@chakra-ui/react';

export function FormControl(props: ChakraFormControlProps) {
  return <ChakraFormControl {...props} />;
}
